import styled from 'styled-components';

export const MenuTitleContainer = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .add-button,
  .more-actions {
    opacity: 0;
    transition: opacity 50ms ease-in;
  }
  .add-button:focus-within,
  .more-actions:focus-within {
    opacity: 1;
  }

  &:hover {
    .add-button,
    .more-actions {
      opacity: 1;
    }
  }
`;

export const ActionMenu = styled.div`
  opacity: 0;
  transition: opacity var(--animation-duration-fast) ease-in;
  position: absolute;
  right: var(--spacing-04);
  background: var(--coolest-gray-10);
  top: 0;
`;
